import React, { Fragment } from 'react'
import MetaTagComponent from '../../../common/Meta/MetaTagComponent'
import { metaMobileAppDevelopment } from '../../../../Utilites'
import ServiceDetailSection from '../../../services/ServiceDetailSection'
import { BarChart3, Cloud, Code, Crosshair, Database, Globe, HandHeart, Rocket, Shield, Smartphone, Star, TrendingUp, Zap } from 'lucide-react'

const MobileAppDevelopment = () => {
  const service = {
    slug: 'mobile-app-development',
    title: 'Mobile App Development',
    description: 'Native and cross-platform mobile applications for iOS and Android with seamless user experiences.',
    shortDescription: 'Native and cross-platform mobile apps for iOS and Android.',
    icon: Smartphone,
    gradient: 'from-green-500 to-emerald-500',
    features: [
      'iOS & Android Development',
      'Cross-Platform Solutions',
      'App Store Optimization',
      'Push Notifications',
      'Offline Functionality',
      'Analytics Integration'
    ],
    benefits: [
      'Native Performance',
      'Platform-Specific Features',
      'Enhanced User Engagement',
      'App Store Visibility'
    ],
    process: [
      'Concept & Planning',
      'Design & Prototyping',
      'Development & Testing',
      'App Store Submission',
      'Post-Launch Support'
    ],
    image: '/assets/img/services/details/mobile-app-development-service.png'
  }

  const extension = {
    keyFeatures: [
      { name: 'Native Performance', description: 'Optimized for iOS and Android platforms', icon: Smartphone },
      { name: 'Cross-Platform Development', description: 'One codebase for multiple platforms', icon: Globe },
      { name: 'Offline Functionality', description: 'Works seamlessly without internet connection', icon: Shield },
      { name: 'Push Notifications', description: 'Engage users with targeted notifications', icon: Zap },
      { name: 'App Store Optimization', description: 'Maximize visibility in app stores', icon: TrendingUp },
      { name: 'Analytics Integration', description: 'Track user behavior and app performance', icon: BarChart3 }
    ],
    benefits: [
      { title: 'Native Performance', description: 'Smooth, fast, and responsive user experience', icon: Rocket },
      { title: 'Platform-Specific Features', description: 'Leverage unique platform capabilities', icon: Star },
      { title: 'Enhanced User Engagement', description: 'Keep users engaged with your brand', icon: HandHeart },
      { title: 'App Store Visibility', description: 'Reach millions of potential users', icon: Crosshair }
    ],
    process: [
      { step: 'Concept & Planning', description: 'Define app concept and user journey', duration: '1-2 weeks' },
      { step: 'Design & Prototyping', description: 'Create UI/UX designs and interactive prototypes', duration: '2-3 weeks' },
      { step: 'Development & Testing', description: 'Build app with rigorous testing', duration: '6-12 weeks' },
      { step: 'App Store Submission', description: 'Submit to Apple App Store and Google Play', duration: '1-2 weeks' },
      { step: 'Post-Launch Support', description: 'Ongoing maintenance and feature updates', duration: 'Ongoing' }
    ],
    techStack: [
      { name: 'React Native', icon: Smartphone, category: 'Framework' },
      { name: 'Flutter', icon: Smartphone, category: 'Framework' },
      { name: 'Swift', icon: Code, category: 'iOS' },
      { name: 'Kotlin', icon: Code, category: 'Android' },
      { name: 'Firebase', icon: Cloud, category: 'Backend' },
      { name: 'Redux', icon: Database, category: 'State Management' }
    ]
  }

  return (
    <Fragment>
        <MetaTagComponent metaDetails={metaMobileAppDevelopment}/>
        <ServiceDetailSection service={service}  extension={extension} />
    </Fragment>
  )
}

export default MobileAppDevelopment